import React, { useEffect, useState } from "react";
import SPRCard from "./SamagaraReportCard/SamagraPRCard";
import SSPRCard from "./SSPRCard";
import { useSelector } from "react-redux";
import "../Assessts/Styles/PReortcard.scss";
const PReportCard = () => {
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  return (
    <>
      {SelectDate?.assessmentType === 3 ? (
        <SPRCard />
      ) : (
        <SSPRCard />
        // <span style={{ padding: "550px" }}>
        //   Sodhana or Sadhana Reports will be available sooner.
        // </span>
      )}
    </>
  );
};
export default PReportCard;
